import { useState,useEffect } from 'react'
import { toast } from 'react-toastify'
import { Alert } from '@mui/material'
import QrReader from 'modern-react-qr-reader'

const Scan = () => {

    const [result,setResult] = useState(null)

    useEffect(() => {
        if(result != null)
            window.open(`${result}&callback=${process.env.REACT_APP_TRANSACTION_CALLBACK_URL_WITHOUT_LOGIN}`,'_blank')
    },[result])

    const isPhone = navigator.share

    return (
        <>
            {isPhone ? <QrReader delay={300} facingMode="environment" onScan={result => setResult(result)} onError={error => toast.error('خطایی در پردازش تصویر رخ داده است')} /> : <Alert severity="info" sx={{my: 3}}>این عملیات فقط در موبایل امکان پذیر است</Alert>}
        </>
    )
}

export default Scan